import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { Modal as AntModal } from "antd";
import { toast } from "react-toastify";


const FarmerSeasonList = (props) => {
  const [farmers, setFarmers] = useState([]);
  const [filteredFarmers, setFilteredFarmers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  const { sendRequest: fetchFarmers } = useHttp();
  const { sendRequest: deleteFarmerSeason } = useHttp();

  const deleteData = (farmerId) => {
  AntModal.confirm({
    title: "Confirm Deletion",
    content: "Are you sure you want to delete this farmer season record?",
    onOk() {
      deleteFarmerSeason(
        {
          url: "/api/deleteFarmerSeason/",
          method: "POST",
          body: {
            action: "delete",
            farmerIds: [farmerId],
            empId: localStorage.getItem("empId"),
          },
        },
        (res) => {
          toast.success("Season removed successfully!");
          setFarmers(prev => prev.filter(f => f.farmerId !== farmerId));
          setFilteredFarmers(prev => prev.filter(f => f.farmerId !== farmerId));

          setCurrentPage(1); 
        }
      );
    }
  });
};


useEffect(() => {
  fetchFarmers(
    {
      url: `/api/getAllFarmersWeb/?orgId=${localStorage.getItem("orgId")}`,
    },
    (res) => {
      if (Array.isArray(res)) {
        setFarmers(res);
        setFilteredFarmers(res);
      }
    }
  );
}, []);  


  useEffect(() => {
    const lowerSearch = searchTerm.toLowerCase();
    const filtered = farmers.filter(
      (f) =>
        f.farmerName?.toLowerCase().includes(lowerSearch) ||
        f.farmerNo?.toLowerCase().includes(lowerSearch) ||
        f.lga?.toLowerCase().includes(lowerSearch) ||
        f.seasonName?.toLowerCase().includes(lowerSearch)
    );
    setFilteredFarmers(filtered);
    setCurrentPage(1);
  }, [searchTerm, farmers]);

  // ✅ Pagination logic (applied on filtered data)
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredFarmers.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="content-wrapper">
      <section className="content">
        <div className="container-fluid">
          <div className="card card-default">
            {/* Header */}
            <div
              className="card-header"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              <h3 className="card-title mb-0"><b>Farmer Season List</b></h3>

              <div
                className="d-flex align-items-center"
                style={{ gap: "10px", marginLeft: "auto" }}
              >
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => props.addForm(true)}
                >
                  <i className="fas fa-plus mr-1" /> Add Season to Farmer
                </button>
              </div>
            </div>

            {/* Body */}
            <div className="card-body">
              {/* Search Field */}
              <div className="row mb-3">
                <div
                  className="col-md-4 d-flex align-items-center"
                  style={{ marginLeft: "auto" }}
                >
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>

              {/* Table */}
              <div className="row">
                <div className="table-responsive">
                  <table className="table table-bordered text-center">
                    <thead>
                      <tr>
                        <th>Farmer Name</th>
                        <th>Farmer No</th>
                        <th>LGA</th>
                        <th>Season Name</th>
                        <th>Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.length > 0 ? (
                        currentItems.map((f) => (
                          <tr key={f.farmerId}>
                            <td>{f.farmerName}</td>
                            <td>{f.farmerNo}</td>
                            <td>{f.lga}</td>
                            <td>{f.seasonName || ""}</td>
                            <td>
                              <button
                                className="btn"
                                onClick={() => deleteData(f.farmerId)}
                              >
                                {" "}
                                <i className="fas fa-trash"></i>
                              </button>
                            </td>

                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="text-center">
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div
                className="card-footer clearfix d-flex justify-content-end"
                style={{ borderTop: "1px solid #dee2e6", background: "#fff" }}
              >
                <Pagination
                  totalItems={farmers.length}
                  itemsPerPage={itemsPerPage}
                  onPageChange={paginate}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FarmerSeasonList;
